// extracted by mini-css-extract-plugin
module.exports = {"GallerySlider":"GallerySlider_GallerySlider__EdP6N","GallerySlider__inner":"GallerySlider_GallerySlider__inner__tW7_u"};